<template>
	<div>
		<div
			class="modal fade modal-fullscreen-mobile"
			ref="modal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
			data-focus="false"
		>
			<div class="modal-dialog vld-parent" role="document">
				<div class="modal-content">
					<div class="modal-header modal-header-banner">
						<button
							type="button"
							class="modal-close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<i class="sk-icon-times"></i>
						</button>
						<div
							class="modal-header-top"
							:style="{ background: backgroundStyle }"
						></div>
						<div class="modal-header-bottom">
							<h1 class="modal-title">Pre Order</h1>
							<div class="modal-subtitle">
								Welcome to {{ businessName }}! The menu is not
								currently available, however you can place a pre
								order for later.
							</div>
							<div class="business-address">
								<i class="sk-icon-map-marker-alt-solid"></i>
								{{ businessAddress }}
							</div>
						</div>
					</div>
					<div class="modal-body">
						<div class="slot-dates">
							<div
								v-for="(preorderDate, i) in preorderDates"
								:key="i"
								:class="{
									'selected-date': date == preorderDate.date,
									disabled: preorderDate.closed
								}"
								class="slot-date"
								@click="selectDate(preorderDate)"
							>
								<div>
									{{ preorderDate.formattedDayOfWeek }}
								</div>
								<div v-if="!preorderDate.closed">
									{{ preorderDate.formattedDay }}
								</div>
								<div v-else>C</div>
							</div>
						</div>
						<div class="sk-divider-wrapper">
							<div class="divider"></div>
						</div>
						<div
							v-if="selectedDate"
							class="slot-times sk-scrollbar"
						>
							<div
								v-for="(slot, i) in selectedDate.slots"
								:key="i"
								class="slot-time"
							>
								<div>{{ slot | formattedTime }}</div>
								<SkRadio :option="slot" v-model="time" />
							</div>
						</div>
						<div class="empty-slots" v-else>No times available</div>
					</div>
					<div class="action-container">
						<button
							@click="setDeliveryTime"
							class="button button-primary"
						>
							{{ confirmationButtonText }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-content {
	max-height: calc(100vh - 56px);
}

.modal-header-banner {
	display: block;
	height: auto;
	overflow: hidden;
	flex-shrink: 0;
}

.modal-header-top {
	background-size: cover !important;
	height: 150px;
	width: 100%;
}

.modal-header-bottom {
	background: var(--gR-base-80);
	height: 135px;
	padding: 0 15px 0 22px;
}

.modal-title,
.modal-subtitle,
.business-address {
	color: var(--gR-white);
}

.modal-title {
	font-size: 18px;
	margin: 14px 0 12px 0 !important;
	font-weight: 600;
}

.modal-subtitle {
	font-size: 12px;
	margin-bottom: 25px;
}

.business-address {
	font-size: 10px;
	margin-bottom: 20px;
}

.business-address i {
	color: var(--gR-white);
	margin-right: 10px;
}

.modal-body {
	width: 100%;
	min-height: 0;
	padding-bottom: 0;
}

.slot-dates {
	display: flex;
	justify-content: space-between;
	width: 100%;
}

.slot-date {
	width: 50px;
	height: 50px;
	font-size: 14px;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	cursor: pointer;
}

.slot-date.selected-date {
	background: var(--gR-teal-70);
	border-radius: 2px;
}

.slot-date.selected-date div {
	color: var(--gR-white);
}

.slot-date.disabled {
	cursor: none;
	pointer-events: none;
}

.slot-date.disabled div {
	color: var(--sk-grey2);
}

.slot-date div {
	color: var(--gR-base-80);
}

.slot-date div:last-child {
	font-size: 12px;
}

.slot-times {
	width: 100%;
	overflow-y: auto;
	padding: 25px 0;
}

.empty-slots {
	font-size: 14px;
	color: var(--gR-base-80);
	text-align: center;
	padding: 25px 0;
}

.slot-time {
	display: flex;
	justify-content: space-between;
}

.slot-time div {
	font-size: 14px;
	color: var(--gR-base-80);
}

.slot-time + .slot-time {
	margin-top: 40px;
}

* >>> .sk-radio {
	width: 20px;
	height: 20px;
}

.action-container {
	height: 80px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 80px;
	border-top: 1px solid var(--gR-white2);
	flex-shrink: 0;
}

.action-container .button-primary {
	max-width: 335px;
	padding: 0 20px;
}

.sk-divider-wrapper {
	margin: 25px 0 0 0;
}

@media only screen and (max-width: 500px) {
	.modal-content {
		max-height: 100%;
	}
}
</style>

<script>
import moment from "moment"
import SkRadio from "@/components/common/SkRadio.vue"
import { eventBus } from "@/eventBus"
import { EventBusEvents } from "@/enums/EventBusEvents"
import { NotificationType } from "@/enums/NotificationType"

export default {
	name: "PreorderOnlyModal",
	components: {
		SkRadio
	},
	filters: {
		formattedTime: function (time) {
			return time != null ? moment(time, "HH:mm:ss").format("h:mm A") : ""
		}
	},
	data: function () {
		return {
			date: null,
			time: null
		}
	},
	computed: {
		businessName() {
			if (this.$store.state.business) {
				return this.$store.state.business.name
			}
			return ""
		},
		businessAddress() {
			return this.$store.getters.businessAddress
		},
		backgroundFileSuffix() {
			let imgNameFull = this.$store.state.business
				? this.$store.state.business.img
				: null
			if (!imgNameFull) {
				return null
			}
			return (
				process.env.VUE_APP_BASE_IMAGE_URL +
				this.$route.params.slug +
				"/" +
				this.$store.state.business.img
			)
		},
		backgroundStyle() {
			if (this.backgroundFileSuffix) {
				let gradient =
					"linear-gradient(1.36deg, var(--gR-base-80) 1.02%, rgba(46, 60, 73, 0) 98.72%) 0% 0% / cover,"
				return `${gradient}url(${this.backgroundFileSuffix}) center no-repeat`
			}
			return ""
		},
		preorderDates() {
			const preorderDates = []
			if (this.$store.getters.preorderOnlySlots) {
				for (let day in this.$store.getters.preorderOnlySlots) {
					const preorderDay =
						this.$store.getters.preorderOnlySlots[day]
					const dayMoment = moment.utc(day, "YYYY-MM-DD")
					preorderDates.push({
						date: day,
						formattedDayOfWeek: preorderDay.isToday
							? "Today"
							: dayMoment.format("ddd"),
						formattedDay: dayMoment.format("DD"),
						slots: preorderDay.slots,
						closed:
							preorderDay.slots && preorderDay.slots.length == 0
					})
				}
			}
			return preorderDates
		},
		selectedDate() {
			return this.date
				? this.preorderDates.find(
						(preorderDay) => preorderDay.date == this.date
				  )
				: null
		},
		confirmationButtonText() {
			if (!this.date) {
				return "Select a date"
			}
			if (!this.time) {
				return "Select a time"
			}
			const formattedDate = moment
				.utc(this.date, "YYYY-MM-DD")
				.format("M / DD")
			const formattedTime = this.$options.filters.formattedTime(this.time)
			return `Start Order for ${formattedDate} at ${formattedTime}`
		}
	},
	methods: {
		open(options) {
			let isModalOpen = $(this.$refs.modal).is(":visible")
			if (isModalOpen) {
				return
			}
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Preorder Only Modal Opened"
			})
			$(this.$refs.modal).modal("show")

			if (options && options.date) {
				this.date = options.date.date
				this.time = options.date.time
			}
		},
		selectDate(preorderDate) {
			this.date = preorderDate.date
			if (
				this.time &&
				this.selectedDate &&
				this.selectedDate.slots &&
				this.selectedDate.slots.length > 0
			) {
				if (this.selectedDate.slots.indexOf(this.time) == -1) {
					this.time = null
				}
			} else {
				this.time = null
			}
		},
		selectTime(time) {
			this.time = time
		},
		setDeliveryTime() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Preorder Only Delivery Time Confirmed",
				data: {
					date: this.date,
					time: this.time
				}
			})
			if (!this.date) {
				eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
					message: "Please select a date",
					type: NotificationType.WARNING
				})
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Preorder Only Delivery Date Missing",
					data: {
						date: this.date,
						time: this.time
					}
				})
				return
			}

			if (!this.time) {
				eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
					message: "Please select a time",
					type: NotificationType.WARNING
				})
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Preorder Only Delivery Time Missing",
					data: {
						date: this.date,
						time: this.time
					}
				})
				return
			}

			if (
				this.$store.state.deliveryDate != null &&
				this.$store.getters.itemsInCartCount > 0
			) {
				this.$emit("confirm", {
					confirmed: (hasConfirmed) => {
						if (hasConfirmed) {
							this.$store.dispatch("setDeliveryDate", {
								date: this.date,
								time: this.time
							})
						}
						this.close()
					}
				})
			} else {
				this.$store.dispatch("setDeliveryDate", {
					date: this.date,
					time: this.time
				})
				this.close()
			}
		},
		close() {
			$(this.$refs.modal).modal("hide")
		}
	}
}
</script>
